import { FC, useMemo } from 'react'
import { GetServerSideProps } from 'next'

import RecommendationContext from 'context/recommendationContext'
import LikeWrap from 'containers/like-wrap/like-wrap'
import MainLayout from 'containers/main-layout/main-layout'
import ArticlePodcast from 'components/articles/article-podcast/article-podcast'
import SEOBreadCrumbs from 'components/parts/seo-metatags/seo-breadcrumbs'
import SEOMetatags from 'components/parts/seo-metatags/seo-metatags'
import SEOContext from 'context/SEOContext'
import useRecommendation from 'hooks/useRecomendation'
import useSetView from 'hooks/useSetView'

import nestRequest from 'utils/server-side/nestRequest'
import { go404 } from 'utils/redirect'
import { getDigitFromString } from 'utils/getURLData'
import { URL } from 'constants/SEO'
import { Pathname } from 'constants/data'
import { IArticle } from 'components/articles/article-material/article-material.type'
import { IPodcast } from 'components/articles/article-podcast/article-podcast.type'
import { PodcastBC } from 'constants/SEO-breadcrumbs'
import { PLACEFLAG_PODCAST } from 'constants/analytic-data'
import { useARegAndLogin, originReg } from 'utils/analytics/other/registration/registration'

interface PodcastPage {
  podcastData: IPodcast
}

const PodcastPage: FC<PodcastPage> = ({ podcastData }) => {
  const recommendData = useRecommendation(podcastData.id, 'webinar', 2)

  useSetView({ materialId: podcastData.id, materialType: 'podcast' })

  const SEOData = useMemo(
    () => ({
      TITLE: `Подкаст: ${podcastData.name}`,
      DESCRIPTION: podcastData.description,
      LINK: URL + '/' + Pathname.PODCAST + '/' + podcastData.id,
      type: 'podcast',
      id: podcastData.id,
      place: PLACEFLAG_PODCAST,
    }),
    [podcastData.id]
  )

  const SEOPodcastBC = useMemo(
    () =>
      PodcastBC({
        id: podcastData.id.toString(),
        name: podcastData.name,
      }),
    [podcastData.id]
  )
  useARegAndLogin(originReg.PODCAST)
  return (
    <>
      <SEOMetatags data={SEOData} />
      <SEOBreadCrumbs data={SEOPodcastBC} />
      <SEOContext.Provider value={SEOData}>
        <LikeWrap>
          <MainLayout>
            <RecommendationContext.Provider value={recommendData}>
              <ArticlePodcast {...podcastData} />
            </RecommendationContext.Provider>
          </MainLayout>
        </LikeWrap>
      </SEOContext.Provider>
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  let podcastData = {} as IArticle

  if (context?.params?.id) {
    try {
      const podcastId = getDigitFromString(context.params.id as string)
      const restRet = await nestRequest(context, 'get', `/api/podcast/${podcastId}`, {})
      podcastData = restRet?.data

      if (!podcastData) return go404()

      if (
        podcastData.linkTranslation &&
        podcastData.linkTranslation != (context.params.id as string)
      ) {
        return {
          redirect: {
            destination: `/${Pathname.PODCAST}/${podcastData.linkTranslation}`,
            statusCode: 307,
          },
        }
      }
    } catch (err) {
      console.warn(err)
      return go404()
    }
  }

  return {
    props: {
      podcastData,
    },
  }
}

export default PodcastPage
